import React, { useEffect, useState } from 'react';
import { MDBRadio, MDBSelect, MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBSpinner } from 'mdb-react-ui-kit';
import axios from 'axios';

const Requestors = ({ sessionId, requestor, setRequestor, requestorType, setRequestorType, byRequestOf, setByRequestOf, byRequestOfType, setByRequestOfType }) => {
    const [legislators, setLegislators] = useState([]);
    const [collapse, setCollapse] = useState(false);
    const [selectedOption, setSelectedOption] = useState("0");
    const [isLoading, setIsLoading] = useState(true);
    const [requestorRadioButton, setRequestorRadioButton] = useState('requestor');
    const [requestorOptions, setRequestorOptions] = useState([]);
    const [byRequestOfOptions, setByRequestOfOptions] = useState([]);

    const toTitleCase = (str) => {
        return str.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };

    const fetchData = async () => {
        try {
            setIsLoading(true);
            let requestorOptionsTemp = [];
            let byRequestorOptionsTemp = [];
            let results;

            const requestorApiCalls = [
                axios.post(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/search?limit=9999&offset=0`, { legislatureIds: [sessionId] }),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommittees/findBySessionId?sessionId=${sessionId}`),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/nonStandingCommittees/findByLegislatureId?legislatureId=${sessionId}`),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/electedOfficialPositions`),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/organizations`)
            ];

            const byRequestOfApiCalls = [
                axios.post(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/search?limit=9999&offset=0`, { legislatureIds: [sessionId] }),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommittees/findBySessionId?sessionId=${sessionId}`),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/nonStandingCommittees/findByLegislatureId?legislatureId=${sessionId}`),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/electedOfficialPositions`),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/organizations`),
                axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/staffMembers`)
            ];

            if (requestorRadioButton === 'requestor') {
                results = await Promise.all(requestorApiCalls);
            } else {
                results = await Promise.all(byRequestOfApiCalls);
            }

            let requestorData = [
                ...(results[0]?.data?.content || []).map(item => ({
                    localId: `LEGISLATOR-${item?.id}`,
                    value: item?.id,
                    text: `${item?.lastName || ''}, ${item?.firstName || ''}`,
                    type: 'LEGISLATOR'
                })),
                ...(results[1]?.data || []).map(item => ({
                    localId: `STANDING_COMMITTEE-${item.id}`,
                    value: item.id,
                    text:  toTitleCase(item?.committeeDetails?.committeeCode?.name),
                    type: 'STANDING_COMMITTEE'
                })),
                ...(results[2]?.data || []).map(item => ({
                    localId: `NON_STANDING_COMMITTEE-${item.id}`,
                    value: item.id,
                    text:  toTitleCase(item?.committeeDetails?.committeeCode?.name),
                    type: 'NON_STANDING_COMMITTEE'
                })),
                ...(results[4]?.data || []).map(item => ({
                    localId: `AGENCY-${item?.id}`,
                    value: item?.id,
                    text: `${item?.name || ''}`,
                    type: 'AGENCY'
                }))
            ];

            let byRequestorData = [
                ...(results[1]?.data || []).map(item => ({
                    localId: `STANDING_COMMITTEES-${item.id}`,
                    value: item.id,
                    text: toTitleCase(item?.committeeDetails?.committeeCode?.name),
                    type: 'STANDING_COMMITTEE'
                })),
                ...(results[2]?.data || []).map(item => ({
                    localId: `NON_STANDING_COMMITTEES-${item.id}`,
                    value: item.id,
                    text: toTitleCase(item?.committeeDetails?.committeeCode?.name),
                    type: 'NON_STANDING_COMMITTEE'
                })),
                ...(results[3]?.data || []).map(item => ({
                    localId: `ELECTED_POSITION-${item?.id}`,
                    value: item?.id,
                    text: `${item?.name || ''}`,
                    type: 'ELECTED_POSITION'
                })),
                ...(results[4]?.data || []).map(item => ({
                    localId: `ORGANIZATION-${item?.id}`,
                    value: item?.id,
                    text: toTitleCase(item?.name),
                    type: 'ORGANIZATION'
                }))
            ];

            requestorOptionsTemp = [{ localId: "0", value: "0", text: "-- Select Requester --", disabled: true }, ...requestorData];
            requestorOptionsTemp.sort((a, b) => a.text.localeCompare(b.text));
            byRequestorOptionsTemp = [{ localId: "0", value: "0", text: "-- Select Requester --", disabled: true }, ...byRequestorData];
            byRequestorOptionsTemp.sort((a, b) => a.text.localeCompare(b.text));

            setRequestorOptions(requestorOptionsTemp);
            setByRequestOfOptions(byRequestorOptionsTemp);
            setLegislators(requestorOptionsTemp);
        } catch (error) {
            console.error('Error fetching data: ', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        try {
            if (sessionId) fetchData();
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
        }
    }, [sessionId]);

    useEffect(() => {
        if (!requestor && !byRequestOf) {
            setSelectedOption("0");
            setByRequestOf(false);
            setByRequestOfType(false);
            setRequestor(false);
            setRequestorType(false);
        }
    }, [requestor, byRequestOf]);

    const handleRequestorSelect = (localId) => {
        if (localId === "0" || !localId) {
            setSelectedOption("0");
            setRequestor(false);
            setByRequestOf(false);
        } else {
            setSelectedOption(localId);
            const selected = legislators.find(option => option.localId === localId);
            if (selected) {
                if (requestorRadioButton === 'requestor') {
                    setRequestor(selected.value);
                    setRequestorType(selected.type);
                    setByRequestOf(false);
                    setByRequestOfType(false);
                } else {
                    setByRequestOf(selected.value);
                    setByRequestOfType(selected.type);
                    setRequestor(false);
                    setRequestorType(false);
                }
            }
        }
    };

    const handleRequestorRadioButtonChange = (event) => {
        const value = event.target.value;
        setRequestorRadioButton(value);
        if (value === 'byrequestof') {
            setLegislators(byRequestOfOptions);
            setByRequestOfType('byrequestof');
        } else {
            setLegislators(requestorOptions);
            setRequestorType('requestor');
        }
        setSelectedOption("0");
    };

    return (
        <>
            {
                sessionId < 1000 ?
                    <MDBSideNavItem>
                        <MDBSideNavLink className='accordion-button' icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                            Requester
                        </MDBSideNavLink>
                        <MDBSideNavCollapse show={collapse}>
                            <li className='p-3'>
                                {isLoading ? (
                                    <span className='mx-4'><MDBSpinner size='sm' role='status' tag='span' className='me-2' /> Loading...</span>
                                ) : (
                                    <MDBSelect
                                        className='legmt-checkbox'
                                        clearBtn
                                        onValueChange={({ value }) => { handleRequestorSelect(value); }}
                                        data={legislators.map(item => ({ value: item.localId, text: item.text }))}
                                        value={selectedOption}
                                        id="legislatorsFilter"
                                        search
                                    />
                                )}
                            </li>
                            <li className='p-3'>
                                <MDBRadio name='RequestorTypeRadioButton' checked={requestorRadioButton == 'requestor'} onChange={handleRequestorRadioButtonChange} id='requestor' value='requestor' label='Requester' inline />
                                <MDBRadio name='RequestorTypeRadioButton' checked={requestorRadioButton == 'byrequestof'} onChange={handleRequestorRadioButtonChange} id='byRequestOf' value='byrequestof' label='By Request Of' inline />
                            </li>
                        </MDBSideNavCollapse>
                    </MDBSideNavItem>
                    :
                    <></>
            }
        </>
    );
};

export default Requestors;